var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"grid-list-md":"","text-xs-center":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},_vm._l((_vm.computers),function(computer,index){return _c('v-flex',{key:index,attrs:{"xs2":""}},[_c('nb-supervisor-pc',{attrs:{"computer":computer},on:{"stateChanged":function($event){return _vm.loadData()}}})],1)}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }